var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveWithOthers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1603 27.8086C99.1214 27.8086 99.0812 27.8088 99.0421 27.8093C90.8492 27.877 84.2418 34.9583 84.3131 43.5942C84.3839 52.1892 91.0428 59.1343 99.1827 59.1343C99.2218 59.1343 99.2618 59.134 99.3009 59.1335C103.318 59.1003 107.067 57.408 109.857 54.3677C112.582 51.3979 114.064 47.4849 114.03 43.3486C113.959 34.7537 107.3 27.8086 99.1603 27.8086Z",
    fill: "#0552B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.955 60.9688H95.3855C83.2295 60.9688 73.3398 70.8584 73.3398 83.0144V92.3476H125V83.0144C125 70.8581 115.111 60.9688 102.955 60.9688Z",
    fill: "#0552B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8204 27.8086C25.7816 27.8086 25.7413 27.8088 25.7022 27.8093C17.5094 27.877 10.9019 34.9583 10.9732 43.5942C11.0443 52.1892 17.703 59.1343 25.8429 59.1343C25.8819 59.1343 25.922 59.134 25.961 59.1335C29.9781 59.1003 33.7271 57.408 36.5172 54.3677C39.2425 51.3979 40.7244 47.4849 40.6903 43.3486C40.6192 34.7537 33.9605 27.8086 25.8204 27.8086Z",
    fill: "#2186EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6147 60.9688H22.0457C9.88965 60.9688 0 70.8581 0 83.0144V92.3476H51.6602V83.0144C51.6602 70.8581 41.7705 60.9688 29.6147 60.9688Z",
    fill: "#2186EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0113 89.1411V99.6221H32.3594V89.1411C32.3594 74.9272 43.9219 63.3672 58.1333 63.3672H67.2373C81.4512 63.3672 93.0113 74.9272 93.0113 89.1411Z",
    fill: "#7CC4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8164 43.4771C79.8164 53.4551 72.1333 61.5728 62.6875 61.5728C62.6265 61.5728 62.563 61.5728 62.502 61.5703C53.1416 61.4653 45.5586 53.3892 45.5586 43.4771C45.5586 33.5625 53.1416 25.4863 62.502 25.3813C62.563 25.3789 62.6265 25.3789 62.6875 25.3789C72.1333 25.3789 79.8164 33.4966 79.8164 43.4771Z",
    fill: "#7CC4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6855 61.5728C62.6245 61.5728 62.561 61.5728 62.5 61.5703V25.3813C62.561 25.3789 62.6245 25.3789 62.6855 25.3789C72.1313 25.3789 79.8145 33.4966 79.8145 43.4771C79.8145 53.4551 72.1313 61.5728 62.6855 61.5728Z",
    fill: "#47A3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0103 89.1411V99.6221H62.5V63.3672H67.2363C81.4502 63.3672 93.0103 74.9272 93.0103 89.1411Z",
    fill: "#47A3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveWithOthers);
export default __webpack_public_path__ + "static/media/live-with-others.207dd789b8d4693de94f19345b42a5fc.svg";
export { ForwardRef as ReactComponent };